import React from "react";

const jobs = [
  {
    dates: "2024 - Present",
    role: "Frontend Software Developer",
    company: "Your Company • Full-time",
    desc: "Describe what you built here — e.g. led development of a customer dashboard, worked on a design system, or shipped a marketplace platform from the ground up.",
  },
];

function WorkExp() {
  return (
    <section id="work-experience" className="container mt-5">
      <h2 className="section-title">Work Experience</h2>
      {jobs.map((job, i) => (
        <div className="work-card" key={i}>
          <p className="work-date">{job.dates}</p>
          <p className="work-role">{job.role}</p>
          <p className="work-company">{job.company}</p>
          <p className="work-desc">{job.desc}</p>
        </div>
      ))}
    </section>
  );
}

export default WorkExp;